import React, { FC, useState } from 'react'
import { Dropdown, DropdownButton, Form } from 'react-bootstrap'

import {
  AutocompleteableItem,
  AutocompleteFilterItem,
  AutocompleteOnSelect,
  onFormChangeable,
  UserType,
} from 'types'
import { EmailInviteDropdownItem } from './EmailInviteDropdownItem'
import { FilteredDropdownItem } from '../FilteredDropdownItem'
import { isEmail } from 'utils/isEmail'
import { NoUserDropdownItem } from '../NoUserDropdownItem'
import { styles } from './styles'
import { FolderSelection } from './FolderSelection'
// import { useTemplatesForProject } from 'hooks/useTemplatesForProject'

const defaultFilterItem = ({ value }: AutocompleteableItem, query: string) => {
  if (query) {
    return value.toLowerCase().includes(query.toLowerCase())
  }
  return true
}

export type AutocompleteSelectProps = {
  projectId?: number | undefined
  templateDocumentId?: number | undefined
  items: AutocompleteableItem[]
  filterItem?: AutocompleteFilterItem
  onSelect: (item: AutocompleteableItem, selectedFolder?: number[]) => void
  initialQuery?: string
  userType: UserType
  selectedFolder?: number[]
  onSelectionHandler: Function
}

export const AutocompleteSelect: FC<AutocompleteSelectProps> = ({
  projectId,
  templateDocumentId,
  items,
  filterItem = defaultFilterItem,
  onSelect,
  userType,
  selectedFolder = [],
  onSelectionHandler,
}) => {
  const [query, setQuery] = useState('')

  const selectOptionAndClearInput: AutocompleteOnSelect = item => () => {
    if (userType === 'Sub-contractor/Foreman' && !selectedFolder.length) {
      alert('Please select atleast one folder')
      return
    }
    onSelect(item, selectedFolder)
    setQuery('')
  }

  const filteredItems = items.filter(item => filterItem(item, query))

  const handleQueryChange = ({ target: { value } }: onFormChangeable) => {
    setQuery(value)
  }

  const queryResults = filteredItems.map(item => (
    <FilteredDropdownItem
      key={item.id && item.id}
      item={item}
      onSelect={selectOptionAndClearInput}
    />
  ))
  const emptyComponent = isEmail(query) ? (
    <EmailInviteDropdownItem
      query={query}
      onSelect={selectOptionAndClearInput}
    />
  ) : (
    <NoUserDropdownItem query={query} />
  )

  const dropdownContent =
    filteredItems.length > 0 ? queryResults : emptyComponent

  const title = `Add a ${userType}`
  const placeholder = `${userType} name or email`

  return (
    <DropdownButton
      title={title}
      variant="icon-person"
      id="user-select"
      style={styles.dropdownButton}>
      {userType === 'Sub-contractor/Foreman' && (
        <FolderSelection
          userType={userType}
          projectId={projectId}
          templateDocumentId={templateDocumentId}
          selectedFolder={selectedFolder}
          onSelectionHandler={onSelectionHandler}
        />
      )}
      <Form.Control
        placeholder={placeholder}
        onChange={handleQueryChange}
        value={query}
      />
      {dropdownContent}
      <Dropdown.Divider />
    </DropdownButton>
  )
}